export default {
  main: {
    site_id: 1141,
    enableWorldCup: true,
    title: 'Terminal PRO Demo',
    showBetBuilderSection: true,
    terminalId: 37837,
    enableMultipleTicketPay: true,
    isTicketsCheckable: true,
    needAdminForResetPin: false,
    mandatoryCasinoLogin: true,
    ticketAvailableViewMode: ['card'],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    isWithdrawal: true,
    enableKeyboardCatching: true,
    enableTicketTimer: true,
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    signInType: 'email',
    enableRegistration: true,
    registrationSteps: [{ name: 'default_register' }],
    registartionCustomField: {
      phoneCode: '+220',
      placeHolder: 'Phone begin with 220...Example 2201234567.',
      registrationPhoneplaceHolder: 'Write phone number without 0. Example 1234567.',
      phoneNumberLength: 11,
    },
    homeBannerSlides: [
      {
        fileType: 'jpeg',
        path: "http://zaxbet.com/en/promotions/all/692641/weekly-sports-cashback",
      },
    ],
    staffPassword: '0',
    enableHeaderAdminSection: true,
    homeMediaSlides: [
      {
        type: 'sport',
        path: 'https://www.zaxbet.com/en/promotions/all/671635/2-selections-lost',
      },
      {
        type: 'sport1',
        path: 'https://www.zaxbet.com/en/promotions/all/671629/1-selection-lost',
      },
      {
        type: 'sport2',
        path: 'https://www.zaxbet.com/en/promotions/all/671622/all-selections-lost',
      },
      {
        type: 'sport3',
        path: 'https://www.zaxbet.com/en/promotions/all/671599/sports-welcome-bonus-free-bet',
      },
      {
        type: 'betbuilder',
        path: 'https://www.zaxbet.com/en/promotions/all/684572/bet-builder',
      },
      {
        type: 'boosted',
        path: 'https://www.zaxbet.com/en/promotions/all/688442/zaxbet-free-bet-tutorial',
      },
      {
        type: 'boosted1',
        path: 'https://www.zaxbet.com/en/promotions/all/680633/profit-booster',
      },
      {
        type: 'casino',
        path: 'https://www.zaxbet.com/en/promotions/all/678171/daily-cashback-on-casino-slots',
      },
      {
        type: 'casino1',
        path: 'https://www.zaxbet.com/en/promotions/all/676577/100-casino-welcome-bonus-up-to-5000-gmd-10000-kes-70-eur-usd',
      },
    ],
    homeFavoritCompetitions: [
      {
        fileType: 'png',
        classname: "remove-layer",
        url: 'http://www.zaxbet.com/en/promotions/all/671635/2-selections-lost'
      },
      {
        fileType: 'png',
        classname: "remove-layer",
        url: "https://www.zaxbet.com/en/promotions/all/671615/all-selections-won"
      },
      {
        fileType: 'png',
        classname: "remove-layer",
        url: 'https://www.zaxbet.com/en/promotions/all/671599/sports-welcome-bonus-free-bet',
      },
    ],
    websitePasswordHash: '',
    logoSize: 'extra-huge-with-height',
    termsAndConditions: false,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    loadUserCurrencyConfig: true,
    useCurrencySymbol: false,
    availableLanguages: {
      '@replace': true,
      eng: {
        short: 'EN',
        name: 'Eng',
        region: 'UnitedKingdom',
        order: 1,
      },
    },
  },
  settingsSection: {
    enabled: true,
    sections: ['adminAccess', 'oddsType', 'language'],
  },
  homePagesUrl: [
    {
      id: 1,
      url: 'betting/live',
      icon: 'global-icon icon-live-circle custom-icons',
      className: 'custom-button',
      name: 'Live',
    },
    {
      id: 1992,
      url: 'betting/prematch/popular',
      icon: 'sport-icon sport-icon-sports-home custom-icons',
      className: 'custom-button',
      name: 'Sports',
    },
    {
      id: 3269,
      url: '/casino-game/37592',
      icon: 'global-icon icon-aviator custom-icons aviator',
      className: 'custom-button',
      name: 'Aviator',
    },
  ],
  userSection: {
    sections: ["changePassword", "betHistory"],
  },
  historyTabConfig: [
    {
      icon: "sports-section",
      title: "Sport",
    },
    {
      icon: "casino-7",
      title: "Casino",
    },
    {
      icon: "terminal-deposit-success",
      title: "Withdrawal",
    },
  ],
  lastTicketButtons: [
    {
      name: 'Bet tickets',
      type: 'betTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Lottery tickets',
      type: 'lotteryTicket',
      hideOnRestrictMode: true,
    },
    {
      name: 'Cash-out',
      type: 'cashoutTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Pay-out',
      type: 'payoutTicket',
      hideOnRestrictMode: false,
    },
  ],
  availableOdds: [
    {
      odds: 'american',
      title: 'American',
      enabled: true,
    },
    {
      odds: 'decimal',
      title: 'Decimal',
      enabled: true,
    },
    {
      odds: 'malay',
      title: 'Malaya',
      enabled: true,
    },
    {
      odds: 'indo',
      title: 'indo',
      enabled: true,
    },
    {
      odds: 'hongkong',
      title: 'hongkong',
      enabled: true,
    },
    {
      odds: 'fractional',
      title: 'Fractional',
      enabled: true,
    },
  ],
  routes: [
        {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
      nestedItems: [
        {
          name: 'Casino',
          type: 'casino',
          url: 'casino',
          enabled: true,
          icon: 'casino-7',
        },
        {
          name: 'Live Casino',
          type: 'liveCasino',
          url: 'liveCasino',
          enabled: true,
          icon: 'casino-categories-LotteryGames',
        },
      ],
    },
    {
      url: 'casino-provider/KRN',
      name: 'Kiron',
      enabled: true,
    },
    {
      id: 3269,
      url: "casino-game/37592",
      icon: "global-icon icon-aviator custom-icons aviator",
      className: "custom-button",
      name: "Aviator",
      enabled: true,
    },
    {
      url: 'https://www.zaxbet.com/en/promotions/all',
      name: 'Promotions',
      outSideLink: true,
      enabled: true,
    },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },
  ],
  defaultTerminalParams: {
    pid: 1141, tid: 37837, token: 'c2WbIg==', currency: 'GMD',
  },
  sportsbook: {
    navigationOrder: ['popular', 'allMatches', 'betBuilder', 'outrights', 'results'],
    enableBoostedOdds: false,
    enablePredefinedMultiples: false,
    asianViewMarket: {
      Soccer: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
            {
              display_key: 'DOUBLE CHANCE',
              title: 'DOUBLE CHANCE',
              side: ['1X', '12', 'X2'],
            },
            {
              display_key: 'NEXTGOALTOSCORE',
              title: 'NEXT GOAL TO SCORE',
              side: ['Home', 'No', 'Away'],
            },
          ],
          [
            {
              display_key: 'BOTHTEAMTOSCORE',
              title: 'Both team to score',
              side: ['Yes', 'No'],
            },
            {
              display_key: 'DRAWNOBET',
              title: 'DRAW NO BET',
              side: ['Home', 'Away'],
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 1.5',
              side: ['Over', 'Under'],
              base: 1.5,
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 2.5',
              side: ['Over', 'Under'],
              base: 2.5,
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 3.5',
              side: ['Over', 'Under'],
              base: 3.5,
            },
            {
              display_key: 'ODD/EVEN',
              market_type: {
                '@in': ['EvenOddTotal', 'FirstHalfEvenOddTotal', 'SecondHalfEvenOddTotal'],
              },
              title: 'Total Goals: Even/Odd',
              side: ['Even', 'Odd'],
            },
            {
              display_key: 'HANDICAP',
              market_type: {
                '@in': ['AsianHandicap', 'HalfTimeAsianHandicap', '2ndHalfAsianHandicap'],
              },
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
            {
              display_key: 'CARDSTOTALS',
              title: 'Yellow Cards: Total',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 1.5',
              side: ['Over', 'Under'],
              base: 1.5,
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 2.5',
              side: ['Over', 'Under'],
              base: 2.5,
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 3.5',
              side: ['Over', 'Under'],
              base: 3.5,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
            {
              display_key: 'DOUBLE CHANCE',
              title: 'DOUBLE CHANCE',
              side: ['1X', '12', 'X2'],
            },
            {
              display_key: 'BOTHTEAMTOSCORE',
              title: 'Both team to score',
              side: ['Yes', 'No'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals',
              side: ['Over', 'Under'],
              alt_main_order: 1,
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 1.5',
              side: ['Over', 'Under'],
              base: 1.5,
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 2.5',
              side: ['Over', 'Under'],
              base: 2.5,
            },
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['OverUnder', 'HalfTimeOverUnder', '2ndHalfTotalOver/Under'],
              },
              title: 'Total Goals 3.5',
              side: ['Over', 'Under'],
              base: 3.5,
            },
            {
              display_key: 'HANDICAP',
              market_type: {
                '@in': ['AsianHandicap', 'HalfTimeAsianHandicap', '2ndHalfAsianHandicap'],
              },
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
          ],
        ],
      },
      Tennis: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'P2'],
            },
            {
              market_type: 'SetHandicap',
              title: 'Set Handicap',
              side: ['Home', 'Away'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['SetOverUnder', 'TotalGamesOver/Under'],
              },
              title: 'TOTAL GAMES',
              side: ['Over', 'Under'],
            },
            {
              market_type: {
                '@in': ['TotalGamesOddorEven', 'SetTotalGamesOddEven'],
              },
              title: 'TOTAL GAMES ODD OR EVEN',
              side: ['Even', 'Odd'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'P2'],
            },
            {
              market_type: 'SetHandicap',
              title: 'Set Handicap',
              side: ['Home', 'Away'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              market_type: {
                '@in': ['SetOverUnder', 'TotalGamesOver/Under'],
              },
              title: 'TOTAL GAMES',
              side: ['Over', 'Under'],
            },
            {
              market_type: {
                '@in': ['TotalGamesOddorEven', 'SetTotalGamesOddEven'],
              },
              title: 'TOTAL GAMES ODD OR EVEN',
              side: ['Even', 'Odd'],
            },
          ],
        ],
      },
      Basketball: {
        live: [
          [
            {
              title: 'Overtime',
              market_type: 'Overtime',
              side: ['Yes', 'No'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Match Handicap',
              side: ['Home', 'Away'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Match Total',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'ODD/EVEN',
              title: 'Match Total Odd/Even',
              side: ['Even', 'Odd'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner 2 Way',
              col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
          [
            {
              display_key: 'HANDICAP',
              title: 'Match Handicap',
              side: ['Home', 'Away'],
            },
            {
              display_key: 'TOTALS',
              title: 'Match Total',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'ODD/EVEN',
              title: 'Match Total Odd/Even',
              side: ['Even', 'Odd'],
            },
          ],
        ],
      },
      Volleyball: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'P2'],
            },
            {
              market_type: 'HANDICAP',
              title: 'Match points Handicap',
              side: ['Home', 'Away'],
            },
            {
              market_type: 'TOTALS',
              title: 'Total points',
              side: ['Home', 'Away'],
            },
          ],
          [
            {
              market_type: {
                '@in': ['MatchHandicap2', 'PeriodHandicap2'],
              },
              display_key: 'HANDICAP',
              title: 'Handicap (Regular Time)',
              side: ['Home', 'Away'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'P2'],
            },
            {
              market_type: 'HANDICAP',
              title: 'Match points Handicap',
              side: ['Home', 'Away'],
            },
            {
              market_type: 'TOTALS',
              title: 'Total points',
              side: ['Home', 'Away'],
            },
          ],
          [
            {
              market_type: {
                '@in': ['MatchHandicap2', 'PeriodHandicap2'],
              },
              display_key: 'HANDICAP',
              title: 'Handicap (Regular Time)',
              side: ['Home', 'Away'],
            },
          ],
        ],
      },
      Pesapallo: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'TOTALS',
              side: ['Over', 'Under'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 3,
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'TOTALS',
              side: ['Over', 'Under'],
            },
          ],
        ],
      },
      Handball: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 3,
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
            {
              display_key: 'WINNER',
              title: 'Match Result',
              col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
        ],
      },
      BallHockey: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Match Result',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Match Result',
              col_count: 3,
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
          ],
        ],
      },
      Futsal: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 3,
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
            {
              display_key: 'WINNER',
              title: 'Match Result',
              col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
        ],
      },
      RugbyLeague: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 3,
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
            {
              display_key: 'WINNER',
              title: 'Match Result',
              col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
        ],
      },
      RugbyUnion: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 3,
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'Total Goals',
              side: ['Over', 'Under'],
            },
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
              alt_main_order: 1,
            },
            {
              display_key: 'WINNER',
              title: 'Match Result',
              col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
        ],
      },
      WaterPolo: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 3,
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'HANDICAP',
              title: 'Handicap',
              side: ['Home', 'Away'],
            },
          ],
        ],
      },
      Darts: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              market_type: 'TotalSetsOver/Under',
              title: 'TOTAL SETS',
              side: ['Over', 'Under'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              market_type: 'TotalSetsOver/Under',
              title: 'TOTAL SETS',
              side: ['Over', 'Under'],
            },
          ],
        ],
      },
      Chess: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'TOTALS',
              side: ['Over', 'Under'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 3,
              side: ['P1', 'X', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'TOTALS',
              side: ['Over', 'Under'],
            },
          ],
        ],
      },
      default: {
        live: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              // col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'TOTALS',
              side: ['Over', 'Under'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: 'WINNER',
              title: 'Winner',
              col_count: 2,
              side: ['P1', 'P2'],
            },
          ],
          [
            {
              display_key: 'TOTALS',
              title: 'TOTALS',
              side: ['Over', 'Under'],
            },
          ],
        ],
      },
    },
  },
};
